function getScrollbarWidth() {
  // Using document.documentElement is often more accurate for scrollbars than body
  return window.innerWidth - document.documentElement.clientWidth;
}

function updateWidths() {
  const scrollbarWidth = getScrollbarWidth();
  document.body.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`);
  document.body.style.setProperty(
    "--viewportWidth",
    `calc(100vw - ${scrollbarWidth}px)`,
  );
}

const handlePageLoad = () => {
  console.log(Shopify.country);
  const loader = document.getElementById("preloader"); // Removed the #
  setTimeout(() => {
    if (loader) {
      loader.classList.add("loader-hidden");
    }
    updateWidths();
  }, 1000);
};

// Check if page is already loaded (common with fast Shopify servers/caching)
if (document.readyState === "complete") {
  handlePageLoad();
} else {
  document.addEventListener("DOMContentLoaded", handlePageLoad);
}

window.addEventListener("resize", updateWidths);
